import { FieldValues } from 'react-hook-form';
import { IntegratedForm } from '../integrated-form-context';
import { useIntegratedForm } from '../use-integrated-form';

export function FormState(props: {
    children: (formState: IntegratedForm<FieldValues>) => React.ReactElement;
}): React.ReactElement {
    const integratedForm = useIntegratedForm();
    return props.children(integratedForm);
}
